import globals from '../../common/globals';

export default {
  name: 'vx-campaign-our-belief',
  data() {
    return {
      globals,
    };
  },
  props: {
    ourBelief: {
      type: Object,
      default: () => {},
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-our-belief/vx-campaign-our-belief.js